import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

import { GeneratedAccount } from '../types/generated';

/**
 * Normalize a stored phone number to E.164. Accepts both the legacy
 * `{callingCode}-{nationalNumber}` format (e.g. `44-7911123456`) and E.164
 * (e.g. `+447911123456`), so we can read accounts saved in either format.
 * Returns '' when the value is missing or can't be parsed.
 */
export const toE164 = (stored?: string | null): string => {
  if (!stored) {
    return '';
  }
  const candidate = stored.includes('-')
    ? `+${stored.split('-').join('')}`
    : stored;
  return isValidPhoneNumber(candidate) ? candidate : '';
};

/**
 * Format a phone number for persistence. We always save in E.164 going
 * forward, regardless of the input format. Returns '' when the value is
 * missing or can't be parsed.
 */
export const toSavedPhone = (input?: string | null): string => {
  if (!input) {
    return '';
  }
  const parsed = parsePhoneNumber(input);
  return parsed ? parsed.number : '';
};

export const showPhoneStep = (
  user:
    | Pick<GeneratedAccount, 'phone' | 'phoneOptedInAt' | 'phoneOptedOutAt'>
    | undefined,
) => {
  if (user?.phoneOptedOutAt) {
    return false;
  }
  if (toE164(user?.phone) && user?.phoneOptedInAt) {
    return false;
  }
  return true;
};
